// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Date$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as PartnerEarningsApiModel from "../api-model/PartnerEarningsApiModel.bs.js";

function decodeEarning(earning) {
  return {
          amount: Currency.toCurrency(earning.amount),
          _type: earning._type,
          default_title: earning.default_title
        };
}

function decodePartnerEarnings(param) {
  var earning_details = param.earning_details;
  return {
          earnings: List.map(decodeEarning, earning_details.earnings),
          inclusions: List.map((function (param) {
                  return {
                          default_title: param.default_title,
                          amount: Currency.toCurrency(param.amount)
                        };
                }), earning_details.fare_inclusions),
          settlements: List.map((function (param) {
                  return {
                          amount: Currency.toCurrency(param.amount),
                          settlement_ts: Date$Catalyst.make(param.settlement_ts, ""),
                          default_title: param.default_title
                        };
                }), earning_details.settlements)
        };
}

function execute(json) {
  return decodePartnerEarnings(DeccoUtils$Catalyst.resolveResult(PartnerEarningsApiModel.t_decode(json), "PartnerEarningsEntityMapper.re"));
}

export {
  decodeEarning ,
  decodePartnerEarnings ,
  execute ,
  
}
/* Date-Catalyst Not a pure module */
